import React from "react";

function PemegangSaham() {
    return (
        <>
            <article className="pemegang-saham float-left">
                <div className="container-pemegang-saham">
                    <h1>Pemegang Saham</h1>
                    <div className="container-card">
                        <div className="card adp">
                            <p className="company">PT. Adiwisista Daya Pratama</p>
                            <p className="percentage">90%</p>
                        </div>
                        <div className="card aaw">
                            <p className="company">PT. Anugrah Aditama Wisista</p>
                            <p className="percentage">10%</p>
                        </div>
                    </div>
                </div>
            </article>
        </>
    );
}

export default PemegangSaham;